import React from "react";
import { inject, observer } from "mobx-react";
import { ReactComponent as ZoomIn } from "../../svg/zoom-in.svg";
import { ReactComponent as ZoomOut } from "../../svg/zoom-out.svg";

@inject("workAreaStore") @observer
class Zoom extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      zoomValues: [
        200,
        175,
        150,
        125,
        100,
        75,
        50,
        33,
        25,
        10
      ],
    }
  }

  changeHandler = larger => {
    const { workAreaStore } = this.props
    const val = workAreaStore.zoom
    let newval = larger ? val + 5 : val - 5
    if(val >= 200 && larger){
      return
    }
    if(val <= 10 && !larger){
      return
    }
    if(newval % 5 !== 0){
      newval -= newval % 5
    }
    this.props.workAreaStore.updateZoom(newval);
    workAreaStore.setZoomOpen(false)
  };

  toggleZoom(){
    this.props.workAreaStore.setZoomOpen(!this.props.workAreaStore.zoomOpen)
  }

  setZoom(value){
    if(value === this.props.workAreaStore.zoom){
      return
    }
    this.props.workAreaStore.updateZoom(value)
    this.toggleZoom()
  }

  zoomFit(){
    this.props.workAreaStore.calculateZoomForScreen()
  }

  getZoomOptions(){
    const isFit = this.props.workAreaStore.zoom === this.props.workAreaStore.fitValue
    const trueValue = this.props.workAreaStore.zoom && !isFit
    const { zoomValues } = this.state
    return (
      zoomValues.map((value, idx) => (
        <React.Fragment key={value + idx}>
          <div onClick={() => this.setZoom(value)} className={trueValue === value ? 'workarea__zoom-dropup__option selected' : 'workarea__zoom-dropup__option'}>
            <span className='workarea__zoom-dropup__value'>
              {
                value
              }%
            </span>
          </div>
          {
            idx === zoomValues.length - 1 ? (
              <div className={`workarea__zoom-dropup__option ${isFit ? 'selected' : ''}`} onClick={() => this.zoomFit()}>
                <span className='workarea__zoom-dropup__value'>
                  Fit on screen
                </span>
              </div>
            ):
            undefined
          }
        </React.Fragment>
      ))
    )
  }

  render() {
    const { clickAction, className, text, component, ...restProps } = this.props;
    const open = this.props.workAreaStore.zoomOpen
    return (
      <div className='workarea__zoom-display'>
        <ZoomOut className='zoom-icon zoom-out' onClick={() => this.changeHandler(false)} />
        {
          open ? 
          (
            <div className='workarea__zoom-dropup shadow-up'>
              {this.getZoomOptions()}
            </div>
          )
          :
          (
            undefined
          )
        }
        <div 
          className='zoom-input-wrapper d-inline-block'
          style={{
            cursor: 'pointer'
          }}
          onClick={() => this.toggleZoom()}
        >
          <div
            className='form-control zoom-input disabled'
          >
            <span>{`${this.props.workAreaStore.zoom}%`}</span>
          </div>
        </div>
        <ZoomIn className='zoom-icon zoom-in' onClick={() => this.changeHandler(true)} />
      </div>
    );
  }
}

/*

        <input
          className={"slider " + className}
          type="range"
          min={1}
          max={200}
          onChange={this.changeHandler}
          value={this.props.workAreaStore.zoom}
        />
*/

export default Zoom;
